<template>
  <section>
    <b-container>
      <div class="learning-path">
        <div class="title">
          <div class="border-vertical"></div>
          <div>
            <h4>Explore Topics</h4>
          </div>
        </div>
        <div class="sub-title">
          <h6>
            Already have some ideas on where to begin with? Choose a topic
            below.
          </h6>
        </div>
        <div class="filter-wrapper">
          <div class="btn-box">
            <div class="app-btn selected">Recommended</div>
          </div>
          <div class="btn-box">
            <div class="app-btn">All Topics</div>
          </div>
          <div class="btn-box">
            <div class="app-btn">How to Guide</div>
          </div>
        </div>
        <div class="content">
          <b-row no-gutters>
            <b-col cols="4">
              <div class="card-wrapper">
                <div class="topic-card">
                  <div class="topic-card-wrapper">
                    <div class="coin">
                      <div class="icon">
                        <svg
                          width="58"
                          height="57"
                          viewBox="0 0 58 57"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="28.9055"
                            cy="28.625"
                            r="28.2466"
                            fill="white"
                          />
                          <path
                            d="M40.8591 29.5092C40.0248 28.4303 38.7657 27.6892 37.082 27.2865C39.2261 26.1928 40.1683 24.3366 39.9096 21.7175C39.8232 20.7677 39.5607 19.9446 39.1216 19.2469C38.6822 18.5491 38.0893 17.9881 37.3406 17.5637C36.5925 17.1388 35.7788 16.8153 34.9015 16.5923C34.024 16.3692 33.0165 16.2073 31.8797 16.1067V10.6676H28.5562V15.9556C27.9806 15.9556 27.103 15.9699 25.9232 15.9987V10.6676H22.5992V16.1067C22.1242 16.1211 21.4264 16.1285 20.5056 16.1285L15.9299 16.1067V19.6465H18.3255C19.4191 19.6465 20.0595 20.1358 20.2465 21.1141V27.3088C20.3906 27.3088 20.5056 27.3162 20.592 27.3305H20.2465V36.0068C20.1315 36.7405 19.7143 37.1076 18.9947 37.1076H16.5993L15.9301 41.0575H20.2469C20.5203 41.0575 20.9157 41.0612 21.434 41.0677C21.9519 41.0749 22.3402 41.0786 22.5993 41.0786V46.5823H25.9239V41.1433C26.528 41.158 27.4057 41.165 28.5568 41.165V46.5823H31.8805V41.0786C33.0606 41.0211 34.1074 40.9138 35.0207 40.7549C35.9344 40.5961 36.8088 40.3483 37.6431 40.0099C38.4774 39.672 39.1752 39.2508 39.7363 38.7472C40.2977 38.244 40.7613 37.6034 41.1289 36.8263C41.4952 36.0491 41.7293 35.1498 41.8297 34.128C42.0176 32.1284 41.6937 30.5886 40.8591 29.5092ZM25.9878 19.8833C26.0886 19.8833 26.3728 19.8796 26.8404 19.8724C27.3083 19.865 27.6966 19.8579 28.006 19.8506C28.3154 19.8435 28.7327 19.8615 29.2581 19.9046C29.7833 19.9478 30.2257 20.0055 30.5853 20.0773C30.9449 20.1491 31.341 20.2679 31.7722 20.4334C32.2043 20.5987 32.5494 20.8003 32.8081 21.0376C33.0673 21.275 33.2867 21.5773 33.4662 21.9443C33.6463 22.3111 33.7363 22.732 33.7363 23.2068C33.7363 23.6097 33.6716 23.9767 33.5423 24.3078C33.4132 24.6387 33.2184 24.9158 32.9597 25.1388C32.701 25.3619 32.4342 25.5563 32.1608 25.7217C31.8877 25.887 31.5384 26.0202 31.1141 26.1208C30.6898 26.2216 30.3193 26.3007 30.003 26.3582C29.6864 26.4158 29.2907 26.4555 28.8158 26.477C28.3409 26.4984 27.981 26.5131 27.7365 26.5202C27.4918 26.5273 27.1574 26.5273 26.7328 26.5202C26.308 26.5131 26.0602 26.5093 25.988 26.5093V19.8832H25.9878V19.8833ZM35.0641 34.5815C34.927 34.9126 34.751 35.2005 34.5353 35.4453C34.3193 35.6895 34.035 35.9056 33.6826 36.0924C33.3303 36.2797 32.9882 36.4305 32.6576 36.5456C32.3264 36.6612 31.927 36.7614 31.4598 36.848C30.9915 36.9344 30.5817 36.9952 30.2288 37.0314C29.8765 37.0675 29.4558 37.0961 28.9664 37.1179C28.4773 37.1391 28.0958 37.15 27.8225 37.15C27.5491 37.15 27.2036 37.1461 26.7864 37.1391C26.3688 37.1324 26.1029 37.1287 25.9877 37.1287V29.8332C26.1026 29.8332 26.4444 29.8262 27.0129 29.8115C27.5815 29.797 28.0453 29.7902 28.405 29.7902C28.7647 29.7902 29.2613 29.8115 29.8947 29.855C30.5274 29.8978 31.0599 29.9623 31.4919 30.0486C31.9234 30.1351 32.3943 30.268 32.9055 30.4481C33.4162 30.6279 33.8301 30.8472 34.1468 31.1062C34.4634 31.3657 34.7294 31.6961 34.9451 32.0991C35.1614 32.5019 35.2693 32.9625 35.2693 33.4806C35.2692 33.8839 35.201 34.2503 35.0641 34.5815Z"
                            fill="#F1BC04"
                          />
                        </svg>
                      </div>
                      <div class="text">Bitcoin</div>
                    </div>
                    <div class="action">
                      <svg
                        width="37"
                        height="37"
                        viewBox="0 0 37 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="18.4205"
                          cy="18.625"
                          r="17.9573"
                          fill="#024089"
                        />
                        <path
                          d="M28.817 18.8006C28.8084 18.5916 28.7184 18.3499 28.5685 18.1975L23.676 13.2265C23.3445 12.9416 22.7087 12.8241 22.3382 13.1535C21.9733 13.478 21.9841 14.107 22.3476 14.4328L25.7875 17.9234H8.94155C8.43498 17.9234 8.02417 18.3162 8.02417 18.8007C8.02417 19.2851 8.43497 19.6779 8.94155 19.6779H25.7875L22.3476 23.1686C22.0345 23.4684 21.9767 24.1199 22.3382 24.4478C22.6995 24.776 23.358 24.6712 23.676 24.3746L28.5685 19.4036C28.7359 19.2335 28.8174 19.0338 28.817 18.8005V18.8006Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="card-wrapper">
                <div class="topic-card">
                  <div class="topic-card-wrapper">
                    <div class="coin">
                      <div class="icon">
                        <svg
                          width="58"
                          height="57"
                          viewBox="0 0 58 57"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="28.9055"
                            cy="28.625"
                            r="28.2466"
                            fill="white"
                          />
                          <path
                            d="M40.8591 29.5092C40.0248 28.4303 38.7657 27.6892 37.082 27.2865C39.2261 26.1928 40.1683 24.3366 39.9096 21.7175C39.8232 20.7677 39.5607 19.9446 39.1216 19.2469C38.6822 18.5491 38.0893 17.9881 37.3406 17.5637C36.5925 17.1388 35.7788 16.8153 34.9015 16.5923C34.024 16.3692 33.0165 16.2073 31.8797 16.1067V10.6676H28.5562V15.9556C27.9806 15.9556 27.103 15.9699 25.9232 15.9987V10.6676H22.5992V16.1067C22.1242 16.1211 21.4264 16.1285 20.5056 16.1285L15.9299 16.1067V19.6465H18.3255C19.4191 19.6465 20.0595 20.1358 20.2465 21.1141V27.3088C20.3906 27.3088 20.5056 27.3162 20.592 27.3305H20.2465V36.0068C20.1315 36.7405 19.7143 37.1076 18.9947 37.1076H16.5993L15.9301 41.0575H20.2469C20.5203 41.0575 20.9157 41.0612 21.434 41.0677C21.9519 41.0749 22.3402 41.0786 22.5993 41.0786V46.5823H25.9239V41.1433C26.528 41.158 27.4057 41.165 28.5568 41.165V46.5823H31.8805V41.0786C33.0606 41.0211 34.1074 40.9138 35.0207 40.7549C35.9344 40.5961 36.8088 40.3483 37.6431 40.0099C38.4774 39.672 39.1752 39.2508 39.7363 38.7472C40.2977 38.244 40.7613 37.6034 41.1289 36.8263C41.4952 36.0491 41.7293 35.1498 41.8297 34.128C42.0176 32.1284 41.6937 30.5886 40.8591 29.5092ZM25.9878 19.8833C26.0886 19.8833 26.3728 19.8796 26.8404 19.8724C27.3083 19.865 27.6966 19.8579 28.006 19.8506C28.3154 19.8435 28.7327 19.8615 29.2581 19.9046C29.7833 19.9478 30.2257 20.0055 30.5853 20.0773C30.9449 20.1491 31.341 20.2679 31.7722 20.4334C32.2043 20.5987 32.5494 20.8003 32.8081 21.0376C33.0673 21.275 33.2867 21.5773 33.4662 21.9443C33.6463 22.3111 33.7363 22.732 33.7363 23.2068C33.7363 23.6097 33.6716 23.9767 33.5423 24.3078C33.4132 24.6387 33.2184 24.9158 32.9597 25.1388C32.701 25.3619 32.4342 25.5563 32.1608 25.7217C31.8877 25.887 31.5384 26.0202 31.1141 26.1208C30.6898 26.2216 30.3193 26.3007 30.003 26.3582C29.6864 26.4158 29.2907 26.4555 28.8158 26.477C28.3409 26.4984 27.981 26.5131 27.7365 26.5202C27.4918 26.5273 27.1574 26.5273 26.7328 26.5202C26.308 26.5131 26.0602 26.5093 25.988 26.5093V19.8832H25.9878V19.8833ZM35.0641 34.5815C34.927 34.9126 34.751 35.2005 34.5353 35.4453C34.3193 35.6895 34.035 35.9056 33.6826 36.0924C33.3303 36.2797 32.9882 36.4305 32.6576 36.5456C32.3264 36.6612 31.927 36.7614 31.4598 36.848C30.9915 36.9344 30.5817 36.9952 30.2288 37.0314C29.8765 37.0675 29.4558 37.0961 28.9664 37.1179C28.4773 37.1391 28.0958 37.15 27.8225 37.15C27.5491 37.15 27.2036 37.1461 26.7864 37.1391C26.3688 37.1324 26.1029 37.1287 25.9877 37.1287V29.8332C26.1026 29.8332 26.4444 29.8262 27.0129 29.8115C27.5815 29.797 28.0453 29.7902 28.405 29.7902C28.7647 29.7902 29.2613 29.8115 29.8947 29.855C30.5274 29.8978 31.0599 29.9623 31.4919 30.0486C31.9234 30.1351 32.3943 30.268 32.9055 30.4481C33.4162 30.6279 33.8301 30.8472 34.1468 31.1062C34.4634 31.3657 34.7294 31.6961 34.9451 32.0991C35.1614 32.5019 35.2693 32.9625 35.2693 33.4806C35.2692 33.8839 35.201 34.2503 35.0641 34.5815Z"
                            fill="#F1BC04"
                          />
                        </svg>
                      </div>
                      <div class="text">Bitcoin</div>
                    </div>
                    <div class="action">
                      <svg
                        width="37"
                        height="37"
                        viewBox="0 0 37 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="18.4205"
                          cy="18.625"
                          r="17.9573"
                          fill="#024089"
                        />
                        <path
                          d="M28.817 18.8006C28.8084 18.5916 28.7184 18.3499 28.5685 18.1975L23.676 13.2265C23.3445 12.9416 22.7087 12.8241 22.3382 13.1535C21.9733 13.478 21.9841 14.107 22.3476 14.4328L25.7875 17.9234H8.94155C8.43498 17.9234 8.02417 18.3162 8.02417 18.8007C8.02417 19.2851 8.43497 19.6779 8.94155 19.6779H25.7875L22.3476 23.1686C22.0345 23.4684 21.9767 24.1199 22.3382 24.4478C22.6995 24.776 23.358 24.6712 23.676 24.3746L28.5685 19.4036C28.7359 19.2335 28.8174 19.0338 28.817 18.8005V18.8006Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="card-wrapper mr-0">
                <div class="topic-card">
                  <div class="topic-card-wrapper">
                    <div class="coin">
                      <div class="icon">
                        <svg
                          width="58"
                          height="57"
                          viewBox="0 0 58 57"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="28.9055"
                            cy="28.625"
                            r="28.2466"
                            fill="white"
                          />
                          <path
                            d="M40.8591 29.5092C40.0248 28.4303 38.7657 27.6892 37.082 27.2865C39.2261 26.1928 40.1683 24.3366 39.9096 21.7175C39.8232 20.7677 39.5607 19.9446 39.1216 19.2469C38.6822 18.5491 38.0893 17.9881 37.3406 17.5637C36.5925 17.1388 35.7788 16.8153 34.9015 16.5923C34.024 16.3692 33.0165 16.2073 31.8797 16.1067V10.6676H28.5562V15.9556C27.9806 15.9556 27.103 15.9699 25.9232 15.9987V10.6676H22.5992V16.1067C22.1242 16.1211 21.4264 16.1285 20.5056 16.1285L15.9299 16.1067V19.6465H18.3255C19.4191 19.6465 20.0595 20.1358 20.2465 21.1141V27.3088C20.3906 27.3088 20.5056 27.3162 20.592 27.3305H20.2465V36.0068C20.1315 36.7405 19.7143 37.1076 18.9947 37.1076H16.5993L15.9301 41.0575H20.2469C20.5203 41.0575 20.9157 41.0612 21.434 41.0677C21.9519 41.0749 22.3402 41.0786 22.5993 41.0786V46.5823H25.9239V41.1433C26.528 41.158 27.4057 41.165 28.5568 41.165V46.5823H31.8805V41.0786C33.0606 41.0211 34.1074 40.9138 35.0207 40.7549C35.9344 40.5961 36.8088 40.3483 37.6431 40.0099C38.4774 39.672 39.1752 39.2508 39.7363 38.7472C40.2977 38.244 40.7613 37.6034 41.1289 36.8263C41.4952 36.0491 41.7293 35.1498 41.8297 34.128C42.0176 32.1284 41.6937 30.5886 40.8591 29.5092ZM25.9878 19.8833C26.0886 19.8833 26.3728 19.8796 26.8404 19.8724C27.3083 19.865 27.6966 19.8579 28.006 19.8506C28.3154 19.8435 28.7327 19.8615 29.2581 19.9046C29.7833 19.9478 30.2257 20.0055 30.5853 20.0773C30.9449 20.1491 31.341 20.2679 31.7722 20.4334C32.2043 20.5987 32.5494 20.8003 32.8081 21.0376C33.0673 21.275 33.2867 21.5773 33.4662 21.9443C33.6463 22.3111 33.7363 22.732 33.7363 23.2068C33.7363 23.6097 33.6716 23.9767 33.5423 24.3078C33.4132 24.6387 33.2184 24.9158 32.9597 25.1388C32.701 25.3619 32.4342 25.5563 32.1608 25.7217C31.8877 25.887 31.5384 26.0202 31.1141 26.1208C30.6898 26.2216 30.3193 26.3007 30.003 26.3582C29.6864 26.4158 29.2907 26.4555 28.8158 26.477C28.3409 26.4984 27.981 26.5131 27.7365 26.5202C27.4918 26.5273 27.1574 26.5273 26.7328 26.5202C26.308 26.5131 26.0602 26.5093 25.988 26.5093V19.8832H25.9878V19.8833ZM35.0641 34.5815C34.927 34.9126 34.751 35.2005 34.5353 35.4453C34.3193 35.6895 34.035 35.9056 33.6826 36.0924C33.3303 36.2797 32.9882 36.4305 32.6576 36.5456C32.3264 36.6612 31.927 36.7614 31.4598 36.848C30.9915 36.9344 30.5817 36.9952 30.2288 37.0314C29.8765 37.0675 29.4558 37.0961 28.9664 37.1179C28.4773 37.1391 28.0958 37.15 27.8225 37.15C27.5491 37.15 27.2036 37.1461 26.7864 37.1391C26.3688 37.1324 26.1029 37.1287 25.9877 37.1287V29.8332C26.1026 29.8332 26.4444 29.8262 27.0129 29.8115C27.5815 29.797 28.0453 29.7902 28.405 29.7902C28.7647 29.7902 29.2613 29.8115 29.8947 29.855C30.5274 29.8978 31.0599 29.9623 31.4919 30.0486C31.9234 30.1351 32.3943 30.268 32.9055 30.4481C33.4162 30.6279 33.8301 30.8472 34.1468 31.1062C34.4634 31.3657 34.7294 31.6961 34.9451 32.0991C35.1614 32.5019 35.2693 32.9625 35.2693 33.4806C35.2692 33.8839 35.201 34.2503 35.0641 34.5815Z"
                            fill="#F1BC04"
                          />
                        </svg>
                      </div>
                      <div class="text">Bitcoin</div>
                    </div>
                    <div class="action">
                      <svg
                        width="37"
                        height="37"
                        viewBox="0 0 37 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="18.4205"
                          cy="18.625"
                          r="17.9573"
                          fill="#024089"
                        />
                        <path
                          d="M28.817 18.8006C28.8084 18.5916 28.7184 18.3499 28.5685 18.1975L23.676 13.2265C23.3445 12.9416 22.7087 12.8241 22.3382 13.1535C21.9733 13.478 21.9841 14.107 22.3476 14.4328L25.7875 17.9234H8.94155C8.43498 17.9234 8.02417 18.3162 8.02417 18.8007C8.02417 19.2851 8.43497 19.6779 8.94155 19.6779H25.7875L22.3476 23.1686C22.0345 23.4684 21.9767 24.1199 22.3382 24.4478C22.6995 24.776 23.358 24.6712 23.676 24.3746L28.5685 19.4036C28.7359 19.2335 28.8174 19.0338 28.817 18.8005V18.8006Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="explore-more">
            <div class="btn-box">
              <div class="app-btn">Explore More</div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "TopicSection",
};
</script>

<style lang="scss" scoped>
section {
  background-color: #ffffff;
  padding: 68px 0 76px 0;

  .container {
    max-width: 1174px;
  }
}
.learning-path {
  .title {
    display: flex;
    justify-content: flex-start;
    gap: 12px;

    .border-vertical {
      background: #f1bc04;
      width: 3px;
      height: 25px;
      top: 8px;
      position: relative;
    }
    h4 {
      color: #000000;
      font-size: 35px;
      font-family: Roboto;
      line-height: 41px;
      letter-spacing: 0.05em;
    }
  }

  .sub-title {
    padding-left: 15px;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    color: #000000;
    margin-bottom: 47px;
  }
  .filter-wrapper {
    padding-left: 15px;
    display: flex;
    gap: 20px;
    margin-bottom: 42px;

    .btn-box {
      cursor: pointer;

      .app-btn {
        background-color: transparent;
        border-color: transparent;
        color: #000000;
        font-size: 20px;
        font-weight: 400;
        line-height: 23px;
        padding: 12px 20px;
        border-radius: 20px;

        &.selected {
          color: #ffffff;
          background-color: #024089 !important;
          border-color: #024089 !important;
        }
      }
    }
  }
  .content {
    padding-left: 15px;
    .card-wrapper {
      margin-right: 26px;
      margin-bottom: 45px;
    }
    .topic-card {
      background: #f8f8f8;
      border-radius: 20px;
      padding: 33px;

      .topic-card-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .coin {
          display: flex;
          gap: 25px;
          align-items: center;
        }
      }
    }

    .explore-more {
      margin: 0 auto;
      width: max-content;

      .btn-box {
        cursor: pointer;

        .app-btn {
          width: max-content;
          color: #ffffff;
          background-color: #024089 !important;
          border-color: #024089 !important;
          font-size: 20px;
          font-weight: 400;
          line-height: 23px;
          padding: 12px 20px;
          border-radius: 45px;
        }
      }
    }
  }
}
</style>
